<template>
  <div :class="{ 'web-footer': true, 'en-font': language == 'en', 'cn-font': language == 'cn' }">
    <div class="web-footer-box" v-if="language == 'cn'">
      <div class="web-footer-box-list">
        <div class="web-footer-box-list-cell">
          <span>联系电话：</span>
          <span>{{ configObj.CONNECT_MOBILE }}</span>
        </div>
        <div class="web-footer-box-list-cell">
          <span>邮箱：</span>
          <span>{{ configObj.EMAIL }}</span>
        </div>
        <div class="web-footer-box-list-cell">
          <span v-if="configObj.BEIAN"><a href="http://www.beian.miit.gov.cn/" target="_blank">{{ configObj.BEIAN }}</a></span>
        </div>
        <div class="web-footer-box-list-cell">
          <div class="web-footer-box-list-cell-icon">
            <img class="img-icon" src="~@/assets/gongan.png" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202011065" rel="noreferrer" target="_blank">京公网安备11010202011065号</a>
          </div>
        </div>
      </div>
      <div class="copy-right">
        <span>Copyright © 2024-2025 北京四十人信息科技有限公司版权所有</span>
      </div>
    </div>
    <div class="web-footer-box" v-else>
      <div class="web-footer-box-list">
        <div class="web-footer-box-list-cell">
          <span>Tel：</span>
          <span>{{ configObj.CONNECT_MOBILE }}</span>
        </div>
        <div class="web-footer-box-list-cell">
          <span>Mail：</span>
          <span>{{ configObj.EMAIL }}</span>
        </div>
        <div class="web-footer-box-list-cell">
          <span v-if="configObj.BEIAN"><a href="http://www.beian.miit.gov.cn/" target="_blank">{{ configObj.BEIAN }}</a></span>
        </div>
        <div class="web-footer-box-list-cell">
          <div class="web-footer-box-list-cell-icon">
            <img class="img-icon" src="~@/assets/gongan.png" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202011065" rel="noreferrer" target="_blank">京公网安备11010202011065号</a>
          </div>
        </div>
      </div>
      <div class="copy-right">
        <span>Copyright © Beijing Forty People Information Technology Co., Ltd. 2024-2025</span>
      </div>
    </div>
  </div>
</template>

<script>
import { initConfig } from "@/api";
export default {
  name: "WebFooter",
  props: {
    language: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      configObj: {
        CONNECT_MOBILE: "",
        ADDRESS: "",
        EMAIL: "",
        BEIAN: "",
        PCLOGO: ""
      },
    };
  },
  created() {
    this.getInitCofing();
  },
  methods: {
    async getInitCofing() {
      let _This = this;
      let res = await initConfig();
      if (res && res.code == 200) {
        this.allConfig = res.data;
        if (res.data.length > 0) {
          let temp = {};
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            if (item.config_key == "CONNECT_MOBILE") {
              temp['CONNECT_MOBILE'] = item.config_value;
            } else if (item.config_key == "ADDRESS") {
              temp['ADDRESS'] = item.config_value;
            } else if (item.config_key == "EMAIL") {
              temp['EMAIL'] = item.config_value;
            } else if (item.config_key == "BEIAN") {
              temp['BEIAN'] = item.config_value;
            } else if (item.config_key == "PCLOGO") {
              temp['PCLOGO'] = item.config_value;
            }
          }
          _This.configObj = temp;
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.en-font {
  font-family: Roboto_Light !important;
}
.cn-font {
  font-family: HarmonyOS_Sans_Regular !important;
}
.web-footer {
  padding: 10px 0;
  background-color: #231815;
  &-box {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
    color: #D6CAC3;
    font-size: 12px;
    &-list {
      display: flex;
      justify-content: center;
      &-cell {
        margin-left: 15px;
        &:first-child {
          margin-left: 0;
        }
        &-icon {
          display: flex;
          align-items: center;
          .img-icon {
            width: 16px;
            height: 18px;
            margin-right: 5px;
          }
        }
        a {
          color: #D6CAC3;
          text-decoration: none;
          &:hover {
            color: #ed6f33;
            text-decoration: underline;
          }
        }
      }
    }
    .copy-right {
      padding-top: 10px;
      text-align: center;
      a {
        color: #D6CAC3;
        text-decoration: none;
        &:hover {
          color: #ed6f33;
          text-decoration: underline;
        }
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .web-footer {
    &-box {
      width: calc(100% - 60px);
      padding: 0 30px;
      &-list {
        flex-wrap: wrap;
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .web-footer {
    &-box {
      width: calc(100% - 60px);
      padding: 0 30px;
      &-list {
        justify-content: left;
        flex-direction: column;
        flex-wrap: wrap;
        &-cell {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
